export const collectConfirmedJobIds = (
  jobIds: string[],
  analysisExtras: Record<string, Record<string, unknown> | undefined>,
): string[] => {
  const durationOf = (jobId: string) => Number(analysisExtras[jobId]?.duration) || 0;
  return jobIds
    .filter((jobId) => analysisExtras[jobId]?.analysisStatus === 'done' && durationOf(jobId) > 0)
    .sort((jobId, nextJobId) => durationOf(jobId) - durationOf(nextJobId));
};
